export default __webpack_public_path__ + "static/media/sb-icon.7c18df10.svg";